<template>
  <div>
    <panel title="Kryteria">
      <check-permission slot="toolbar" entity-type="criterion" permissions="CRITERION.ADD">
        <button class="btn btn-primary" @click="addNode({ id: null })">
          <i class="fal fa-fw fa-plus" />
          Dodaj kryterium
        </button>
      </check-permission>

      <async-tree
        aria-label-element-name="kryterium"
        entity-type="criterion"
        permission-name="CRITERION"
        :options="options"
        :root-structure="rootStructure"
        :expand-at-start="true"
        @addNode="addNode"
        @update="beforeUpdate"
        @delete="showDeleteDialog"
        @tree="setTree"
        @expandAll="expandAll"
      />
    </panel>

    <criterion-modal
      :id="idToEdit"
      :entity-type="entityType"
      :parent-id="parentId"
      :show="showModal"
      @save="add"
      @close="hideNodeModal"
      @update="update"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import CriterionModal from '@/components/modals/CriterionModal';
import Panel from '@/components/panel/Panel';
import AsyncTree from '@/components/tree/AsyncTree.vue';
import { CriterionType } from '@/enums/criterionType';
import { listMixin } from '@/mixins/list';
import { treeMixin } from '@/mixins/tree';
import { criterionResource } from '@/resources/criterion.resource';
import { DEFAULT_TABLE_ACTIONS } from '@/utils/constants';

const messages = {
  listError: 'Wystąpił błąd podczas pobierania kryteriów.',
  getError: 'Wystąpił błąd podczas pobierania danych kryterium.',
  added: 'Dodano kryterium.',
  addError: 'Nie udało się dodać kryterium.',
  updated: 'Zaktualizowano dane kryterium.',
  updateError: 'Nie udało się zaktualizować danych kryterium.',
  deleteConfirm: 'Czy na pewno chcesz usunąć kryterium?',
  deleted: 'Usunięto kryterium.',
  deleteError: 'Nie udało się usunąć kryterium.'
};

// @vuese
// Lista Kryteriów
// @group criterion
export default {
  components: { Panel, CriterionModal, AsyncTree },
  mixins: [treeMixin('criterion', messages, 'name', criterionResource)],
  props: {
    // Typ encji
    entityType: {
      type: String,
      required: true
    }
  },
  data: () => ({
    columns: [
      { name: 'id', displayName: 'ID' },
      { name: 'name', displayName: 'Nazwa', sortable: true }
    ],
    actions: DEFAULT_TABLE_ACTIONS
  })
};
</script>
